import {
  MEDIA_LIST_MORE_ACTIONS,
  MEDIA_STATUS,
  ALLOWED_FILE_EXTENSION,
} from "../../constants";
import { DRIVE_TAB } from "@/utils/constants/tabConstants";
import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import { createPortal } from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {
  deleteMedia,
  getMedia,
  getUpdateMedia,
  updateIsFilter,
  trimMedia,
  getSearchedListMedia,
  getListMedia,
  getPresetList,
  getTokenForDownload,
  reuploadMedia,
  getChunkInfo,
} from "@/store/media/media.action";
import {
  addFile,
  increaseCounter,
  decreaseCounter,
  updateFileProgress,
  setUploadedSuccessfully,
  setUploadingError,
} from "@/store/upload/upload.slice";
import { showUploadProgress } from "@/store/app/app.slice";
import { callRegisterCustomMediaOnCms } from "@/store/upload/upload.action";
import { MediaModel } from "@/database";
import SimuliveForm from "@/components/Create/SimuliveForm";
import { RootState, store } from "../../store";
import {
  Send,
  MoreVertical,
  Scissors,
  Download,
  SquarePen,
  Layers2,
  Trash,
  RotateCw,
} from "lucide-react";
import {
  Button,
  toast,
  Tooltip,
  // showToast,
} from "../../components";
import {
  getActionConfigFeatures,
  ActionConfigFeatureMapKey,
} from "@/utils/utilFunctions/Mapper/ActionConfig";
import Modal from "@/components/Modal/Modal";
import {
  emptyAssetDetails,
  emptyMediaDetails,
  setMediaDetails,
  setMediaList,
} from "@/store/media/media.slice";
import { updateModal } from "@/store/app/app.slice";
import MediaDelete, { MediaDeleteRef } from "./MediaDelete";
import { connect, ConnectedProps } from "react-redux";
import VideoTrimmer from "@/components/VideoTrimmer/VideoTrimmer";
import { useScrollToTop } from "../../hooks/useScrollToTop";
import { useScrollOutside } from "../../hooks/useScrollOutside";
import { copyTextToClipboard } from "../../utils";
import styles from "../../scss/media.module.scss";
import { AlertDialog } from "@/utils/ui/AlertDialog/AlertDialog";
import { handleDownloadMedia } from "@/utils/mediaUtils";
import { ProductModel } from "@/database";
import { getTrackUserContext, trackEvent } from "@/utils/analytics";
import { getContentLocation } from "@/utils/utilFunctions/commmonFunctions";
import { runMediaReupload } from "@/utils/createOptionsUtils";

const RenderAction: React.FC<Props> = ({
  media,
  deleteMedia,
  getUpdateMedia,
  setMediaDetails,
  paramFilter,
  emptyAssetDetails,
  emptyMediaDetails,
  getMedia,
  callRegisterCustomMediaOnCms,
  tab,
  getSearchedListMedia,
  getPresetList,
  getListMedia,
  trimMedia,
  presetList,
  preMediaList,
  postMediaList,
  updateModal,
  setIsMediaModalOpen,
  setFooterBtnContent,
  setClonedMedia,
  onPreviewModalClose,
  onRequestTrim,
  onCloneInitiated,
  showCtaText = false,
  fromLibraryPreview = false,
  libraryCtaOrd = ["edit", "send", "trim", "clone"],
  onDropdownStateChange,
  bunchProductList,
  getTokenForDownload,
  reuploadMedia,
  getChunkInfo,
  addFile,
  increaseCounter,
  decreaseCounter,
  updateFileProgress,
  setUploadedSuccessfully,
  setUploadingError,
  showUploadProgress,
}) => {
  const isReadOnlyAccess = (() => {
    if (!media?.team || !bunchProductList?.length) {
      return false;
    }
    const currentTeam = bunchProductList.find(
      (team: ProductModel) => team.id === media?.team
    );
    return currentTeam?.access === "read";
  })();

  const [showMoreOptions, setShowMoreOptions] = useState<boolean>(false);
  const { navigateWithScroll } = useScrollToTop();
  const [showSimuliveForm, setShowSimuliveForm] = useState<boolean>(false);
  const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
  const [showDuplicateForm, setShowDuplicateForm] = useState<boolean>(false);
  const [isMediaDeleteModalOpen, setIsMediaDeleteModalOpen] =
    useState<boolean>(false);
  const mediaDeleteRef = useRef<MediaDeleteRef>(null);
  const [archiveActionType, setArchiveActionType] = useState<
    "delete" | "archive"
  >("delete");
  const [isTrimmerOpen, setIsTrimmerOpen] = useState<boolean>(false);
  const [isFooterBtnDisabled, setIsFooterBtnDisabled] =
    useState<boolean>(false);
  const [footerBtnText, setFooterBtnText] = useState<string>("Create");
  const [isReuploading, setIsReuploading] = useState<boolean>(false);
  const reuploadInputRef = useRef<HTMLInputElement>(null);

  const moreOptionsDropdownRef = useRef<HTMLDivElement>(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const contentLocation = getContentLocation();

  const trackContentAction = (entity: string, action: string = "click") => {
    trackEvent("browse", {
      category: "content",
      entity,
      action,
      location: contentLocation,
      ...getTrackUserContext(),
    });
  };

  // Custom Portal Menu Component
  const PortalMenu: React.FC<{
    children: React.ReactNode;
    triggerRef: React.RefObject<HTMLElement>;
  }> = ({ children, triggerRef }) => {
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          menuRef.current &&
          triggerRef.current &&
          !menuRef.current.contains(event.target as Node) &&
          !triggerRef.current.contains(event.target as Node)
        ) {
          setShowMoreOptions(false);
          onDropdownStateChange?.(false);
        }
      };

      if (showMoreOptions) {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
    }, [showMoreOptions, triggerRef]);

    const updatePosition = useCallback(() => {
      if (!triggerRef.current || !menuRef.current) return;

      const triggerRect = triggerRef.current.getBoundingClientRect();
      const menuRect = menuRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      let top = triggerRect.bottom + window.scrollY;
      let left = triggerRect.right + window.scrollX - menuRect.width;

      // Adjust if menu would go off-screen
      if (left + menuRect.width > viewportWidth) {
        left = viewportWidth - menuRect.width - 10;
      }
      if (left < 0) {
        left = 10;
      }

      // Adjust if menu would go off-screen vertically
      if (top + menuRect.height > viewportHeight + window.scrollY) {
        top = triggerRect.top + window.scrollY - menuRect.height;
      }

      setDropdownPosition((prev) => {
        if (prev.top !== top || prev.left !== left) {
          return { top, left };
        }
        return prev;
      });
    }, []);

    useEffect(() => {
      if (showMoreOptions) {
        const timeoutId = setTimeout(() => {
          updatePosition();
        }, 0);

        const handleUpdate = () => updatePosition();
        window.addEventListener("scroll", handleUpdate);
        window.addEventListener("resize", handleUpdate);

        return () => {
          clearTimeout(timeoutId);
          window.removeEventListener("scroll", handleUpdate);
          window.removeEventListener("resize", handleUpdate);
        };
      }
    }, [showMoreOptions]);

    if (!showMoreOptions) return null;

    const menuElement = (
      <div
        ref={menuRef}
        className="dropdown-menu show"
        style={{
          position: "absolute",
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          zIndex: 1000,
          minWidth: "150px",
          boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
          border: "1px solid rgba(0, 0, 0, 0.15)",
          borderRadius: "0.375rem",
          backgroundColor: "#fff",
        }}
      >
        {children}
      </div>
    );

    return createPortal(menuElement, document.body);
  };

  useScrollOutside({
    isOpen: showMoreOptions,
    onClose: () => {
      setShowMoreOptions(false);
      onDropdownStateChange?.(false);
    },
    enabled: true,
    ref: moreOptionsDropdownRef,
  });

  const mediaState = useMemo(() => {
    const state = {
      isEditable:
        media?.media_status === 2 ||
        media?.media_status === 3 ||
        (media?.content_type && media?.content_type === 2),
      isInDraftState:
        !media?.is_mandatory || (media as MediaModel)?.media_state !== 1,
      isLibraryTab: tab === DRIVE_TAB,
      canTrim:
        media?.meta?.duration &&
        media.meta.duration > 0 &&
        (media.asset_type === "video" || media.asset_type === "library") &&
        media?.source !== "embed" &&
        media?.media_ref?.rel !== "embed",
      isVideo: media.asset_type === "video",
      isDraft: media?.media_status === 0 || media?.media_status === 1,
      isSlate: media?.asset_type === "slates",
      isPremiere: media?.media_ref?.rel === "premiere",
      isDrive: media?.content_type === 2,
    };
    return state;
  }, [
    media?.is_mandatory,
    media?.media_state,
    tab,
    media?.meta?.duration,
    media?.asset_type,
    media?.media_status,
    media?.media_ref?.rel,
  ]);

  type ButtonConfig = {
    size: number;
    className: string;
    icon: React.ComponentType<any>;
    text: string;
    title?: string;
    tooltipText?: string;
    tooltipPlacement?: "top" | "bottom" | "left" | "right";
  };

  type MoreConfig = {
    width: string;
    height: string;
  };

  const buttonConfigs = useMemo(
    () => ({
      draft: {
        size: 16,
        className: "d-flex gap-2 align-items-center p-1",
        icon: SquarePen,
        text: "Edit",
        tooltipText: "Edit draft",
      },
      library: {
        size: 20,
        className: showCtaText
          ? "d-flex gap-2 align-items-center border"
          : "border-0",
        icon: Scissors,
        text: showCtaText ? "Trim" : "",
        title: "Trim",
        tooltipText: "Trim media",
      },
      clone: {
        size: 20,
        className: showCtaText
          ? "d-flex gap-2 align-items-center border"
          : "border-0",
        icon: Layers2,
        text: showCtaText
          ? mediaState.isLibraryTab
            ? "Process"
            : "Clone"
          : "",
        title: "clone",
        tooltipText: mediaState.isLibraryTab ? "Process media" : "Clone media",
      },
      edit: {
        size: 20,
        className: showCtaText
          ? "d-flex gap-2 align-items-center border"
          : "border-0",
        icon: SquarePen,
        text: showCtaText ? "Edit" : "",
        tooltipText: "Edit media",
      },
      send: {
        size: 19,
        className: showCtaText
          ? "d-flex gap-2 align-items-center border"
          : "border-0",
        icon: Send,
        text: showCtaText ? "Social" : "",
        tooltipText: "Send to social",
      },
      download: {
        size: 19,
        className: showCtaText
          ? "d-flex gap-2 align-items-center border"
          : "border-0",
        icon: Download,
        text: "",
        title: "Download",
        tooltipText: "Download media",
      },
      more: {
        width: "22px",
        height: "22px",
      },
    }),
    [showCtaText, mediaState.isLibraryTab]
  );

  const renderButton = (
    type: keyof typeof buttonConfigs,
    onClick: () => void,
    disabled = false,
    extraProps = {}
  ) => {
    const config = buttonConfigs[type];

    if (!("icon" in config)) return null;

    const buttonConfig = config as ButtonConfig;
    const IconComponent = buttonConfig.icon;

    const buttonElement = (
      <Button
        type={
          type === "library" && fromLibraryPreview
            ? "primary"
            : "outline-primary"
        }
        onClick={onClick}
        className={buttonConfig.className}
        isDisabled={disabled}
        title={"title" in buttonConfig ? buttonConfig.title || "" : ""}
        {...extraProps}
      >
        <IconComponent size={buttonConfig.size} />
        {buttonConfig.text && <span>{buttonConfig.text}</span>}
      </Button>
    );

    if (buttonConfig.tooltipText) {
      return (
        <Tooltip
          content={buttonConfig.tooltipText}
          placement={buttonConfig.tooltipPlacement ?? "top"}
        >
          <div className="d-inline-flex">{buttonElement}</div>
        </Tooltip>
      );
    }

    return buttonElement;
  };

  const renderDraftButton = () =>
    mediaState.isDraft && (
      <>
        <Button
          type="outline-primary"
          onClick={() => handleMediaEdit(false)}
          className={
            (buttonConfigs.draft as ButtonConfig).className + " ms-auto"
          }
        >
          <SquarePen size={(buttonConfigs.draft as ButtonConfig).size} />
          {(buttonConfigs.draft as ButtonConfig).text}
        </Button>
      </>
    );

  const renderLibraryButtons = () =>
    mediaState.isLibraryTab &&
    mediaState.isEditable && (
      <>
        {libraryCtaOrd.map((cta) => {
          if (cta === "edit") {
            if (fromLibraryPreview) return null;
            return (
              <React.Fragment key={cta}>
                {renderButton("edit", () => handleMediaEdit(false))}
              </React.Fragment>
            );
          }
          if (cta === "send") {
            return (
              <React.Fragment key={cta}>
                {renderButton(
                  "send",
                  () => handleMediaEdit(true),
                  isReadOnlyAccess
                )}
              </React.Fragment>
            );
          }
          if (cta === "trim") {
            if (mediaState.isDrive && media.state !== 10) return null;
            return (
              <React.Fragment key={cta}>
                {renderButton(
                  "library",
                  handleTrim,
                  !mediaState.canTrim || isReadOnlyAccess
                )}
              </React.Fragment>
            );
          }
          if (cta === "clone") {
            if (mediaState.isDrive && media.state !== 10) return null;
            return (
              <React.Fragment key={cta}>
                {renderButton(
                  "clone",
                  () => handleClone(true),
                  isReadOnlyAccess
                )}
              </React.Fragment>
            );
          }
          return null;
        })}
      </>
    );

  const renderEditButton = () =>
    !mediaState.isLibraryTab &&
    mediaState.isEditable &&
    renderButton("edit", () => handleMediaEdit(false));

  const renderSendButton = () =>
    !mediaState.isLibraryTab &&
    mediaState.isEditable &&
    !mediaState.isSlate &&
    !mediaState.isPremiere &&
    renderButton("send", () => handleMediaEdit(true), isReadOnlyAccess);

  const renderTrimButton = () =>
    !mediaState.isLibraryTab &&
    mediaState.canTrim &&
    renderButton("library", handleTrim, isReadOnlyAccess);

  const renderDownloadButton = () =>
    !mediaState.isLibraryTab &&
    mediaState.isEditable &&
    renderButton(
      "download",
      handleDownload,
      !mediaState.isEditable || isReadOnlyAccess
    );

  const renderDropdownOptions = () => {
    if (mediaState.isLibraryTab) {
      const showDownload = media.status === 5 || media.state === 10;
      return (
        <>
          {showDownload && (
            <Dropdown.Item
              as="button"
              className="text-capitalize"
              onClick={() => handleMediaOptionValue("download")}
              disabled={isReadOnlyAccess}
            >
              download
            </Dropdown.Item>
          )}
          <Dropdown.Item
            as="button"
            className="text-capitalize"
            onClick={() => handleMediaOptionValue("delete")}
            disabled={isReadOnlyAccess}
          >
            delete
          </Dropdown.Item>
        </>
      );
    }
    return MEDIA_LIST_MORE_ACTIONS.filter((option: any) => {
      if (option === "convert to podcast" && !mediaState.isVideo) return false;
      if (
        option === "archive" &&
        media.media_status === MEDIA_STATUS.MEDIA_STATUS_DRAFT
      )
        return false;
      const actionKey = actionButtonMapper[
        option as keyof typeof actionButtonMapper
      ] as keyof typeof actionConfigFeatures;
      return (
        actionConfigFeatures[actionKey]?.enabled &&
        checkingMandatory(actionKey as string)
      );
    }).map((option: string) => (
      <Dropdown.Item
        as="button"
        className="text-capitalize"
        key={option}
        onClick={() => handleMediaOptionValue(option)}
        disabled={isReadOnlyAccess}
      >
        {option === "duplicate"
          ? "clone"
          : option === "archive"
            ? "inactive"
            : option}
      </Dropdown.Item>
    ));
  };

  const renderMoreOptionsDropdown = () =>
    (mediaState.isEditable || mediaState?.isDrive) && (
      <>
        <Dropdown
          ref={moreOptionsDropdownRef}
          show={false} // We'll handle the show state manually with our portal
          onToggle={() => {}} // Disable default toggle behavior
          key={`dropdown-${showMoreOptions}`}
          className={`border-0 ${!mediaState.isEditable ? "disabled" : ""}`}
          align="end"
        >
          <Dropdown.Toggle
            variant="outline-primary"
            className="border-0 no-caret"
            disabled={isReadOnlyAccess}
            onClick={() => {
              if (!isReadOnlyAccess) {
                setShowMoreOptions(!showMoreOptions);
                onDropdownStateChange?.(!showMoreOptions);
              }
            }}
          >
            <MoreVertical
              style={{
                width: (buttonConfigs.more as MoreConfig).width,
                height: (buttonConfigs.more as MoreConfig).height,
              }}
            />
          </Dropdown.Toggle>
        </Dropdown>

        <PortalMenu triggerRef={moreOptionsDropdownRef}>
          {renderDropdownOptions()}
        </PortalMenu>
      </>
    );

  const actionButtonMapper = useMemo(
    () => ({
      download: "download",
      archive: "archive",
      delete: "delete",
      simulive: "create_simulive",
      clone: "create_clone",
      duplicate: "duplicate",
      video: "video",
      podcast: "podcast",
    }),
    []
  );

  const mandatoryActions = useMemo(
    () =>
      new Set([
        "create_simulive",
        "create_clone",
        "duplicate",
        "podcast",
        "podcast",
      ]),
    []
  );

  const checkingMandatory = useCallback(
    (action: string) => {
      return mandatoryActions.has(action) ? media.is_mandatory : true;
    },
    [mandatoryActions, media.is_mandatory]
  );

  const mediatypeList = useMemo(
    () => ["clone", "simulive", "podcast", "embed", "slates", "campaign"],
    []
  );

  const mediatype = useMemo(
    () =>
      mediatypeList.includes(media?.media_ref?.rel || "")
        ? media?.media_ref?.rel
        : "media",
    [mediatypeList, media?.media_ref?.rel]
  );

  const actionConfigFeatures = useMemo(
    () => getActionConfigFeatures(mediatype as ActionConfigFeatureMapKey),
    [mediatype]
  );

  const hideSimuliveForm = useCallback(() => {
    setShowSimuliveForm(false);
  }, []);

  const handleTrim = useCallback(() => {
    if (mediaState.canTrim) {
      trackContentAction("Trim");
      if (onRequestTrim) {
        onRequestTrim(media);
        return;
      }
      setIsTrimmerOpen(true);
      // onPreviewModalClose?.();
    }
  }, [mediaState.canTrim, onRequestTrim, media]);

  const handleTrimmerClose = useCallback(() => {
    setIsTrimmerOpen(false);
  }, []);

  const handlePodcast = useCallback(() => {
    trackContentAction("Podcast");
    emptyAssetDetails();
    emptyMediaDetails();
    callRegisterCustomMediaOnCms(
      {
        type: "podcast",
        name: "media",
        id: media.id,
        title: media.title || "Podcast from Media",
        data: {},
        fid: `${media.id}-${Date.now().toString()}`,
      },
      (response: any) => {
        if (response.status === 200) {
          setClonedMedia?.(response.data);
          getMedia({ id: response.data.id });
          setIsMediaModalOpen(true);
        }
      }
    );
  }, [
    media.id,
    media.title,
    emptyAssetDetails,
    emptyMediaDetails,
    callRegisterCustomMediaOnCms,
    getMedia,
  ]);

  const handleMediaEdit = useCallback(
    (onSocial?: boolean) => {
      trackContentAction(onSocial ? "Social" : "Edit");
      setMediaDetails({
        data: {
          media: media,
        },
      });

      const cleanParams = new URLSearchParams();
      paramFilter.forEach((value: string, key: string) => {
        // if (key === "tab") return;
        if (value && !value.includes("nextInit, navigateOptions")) {
          cleanParams.append(key, value);
        }
      });

      const baseUrl = onSocial ? "social-publish" : "details";
      if (tab) {
        cleanParams.append("tab", tab);
      }
      if (tab === DRIVE_TAB) {
        navigateWithScroll(
          `/media/${media.id}/${baseUrl}?${cleanParams.toString()}`,
          {
            state: {
              returnPath: tab === DRIVE_TAB ? "/drive/video" : undefined,
            },
          }
        );
      } else {
        navigateWithScroll(
          `/media/${media.id}/${baseUrl}?${cleanParams.toString()}`
        );
      }
    },
    [media, paramFilter, tab, setMediaDetails, navigateWithScroll]
  );

  // const handleMediaEdit = useCallback(
  //   (onSocial?: boolean) => {
  //     trackContentAction(onSocial ? "Social" : "Edit");
  //     setMediaDetails({
  //       data: {
  //         media: media,
  //       },
  //     });

  //     const cleanParams = new URLSearchParams();
  //     paramFilter.forEach((value: string, key: string) => {
  //       if (value && !value.includes("nextInit, navigateOptions")) {
  //         cleanParams.append(key, value);
  //       }
  //     });

  //     if (tab) {
  //       cleanParams.append("tab", tab);
  //     }

  //     const baseUrl = onSocial ? "social-publish" : "details";
  //     navigateWithScroll(
  //       `/media/${media.id}/${baseUrl}?${cleanParams.toString()}`
  //     );
  //   },
  //   [media, paramFilter, tab, setMediaDetails, navigateWithScroll]
  // );

  const handleClone = useCallback(
    (trim?: boolean) => {
      if (media === null) return;
      trackContentAction(showDuplicateForm ? "Duplicate" : "Clone");
      onCloneInitiated?.();
      const data = {
        team: "",
        lang: "",
        media: media.id,
        trim: [
          {
            starttime: 0,
            endtime: media.meta.duration,
          },
        ],
        damid: media.damid,
      };
      const mediaType = showDuplicateForm ? "duplicate" : "clone";
      const mediaName = `media${Date.now()}`;
      const fid = `${media.id}-${Date.now().toString()}`;
      if (!trim) {
        callRegisterCustomMediaOnCms(
          { type: mediaType, data, name: mediaName, id: media.id, fid },
          (resp: any) => {
            updateIsFilter(false);
            if (resp.status === 200) {
              setClonedMedia?.({ ...resp.data, team: "", lang: "" });
              setMediaDetails({
                data: {
                  media: {
                    ...resp.data,
                  },
                },
              });
              setIsMediaModalOpen(true);
              onPreviewModalClose?.();
            }
            // Toast handled in callRegisterCustomMediaOnCms action
          }
        );
      } else {
        trimMedia(data)
          .then((response: any) => {
            if (response && response.id) {
              setClonedMedia?.(response);
              setMediaDetails({
                data: {
                  media: {
                    ...response,
                    team: "",
                    lang: "",
                  },
                },
              });
              setIsMediaModalOpen(true);
              onPreviewModalClose?.();
            }
          })
          .catch((error: any) => {
            console.error("Error in clone operation:", error);
            // Error toast handled in trimMedia action
          });
      }
    },
    [
      media,
      showDuplicateForm,
      trimMedia,
      setMediaDetails,
      onPreviewModalClose,
      onCloneInitiated,
    ]
  );

  const handleDownload = useCallback(() => {
    trackContentAction("Download");
    handleDownloadMedia(media, getTokenForDownload);
  }, [media.id, handleDownloadMedia, getTokenForDownload]);

  const mediaActionHandlers = useMemo(
    () => ({
      delete: () => {
        trackContentAction("Delete");
        setArchiveActionType("delete");
        setIsMediaDeleteModalOpen(true);
      },
      archive: () => {
        trackContentAction("Archive");
        setArchiveActionType("archive");
        setIsMediaDeleteModalOpen(true);
      },
      simulive: () => {
        trackContentAction("Simulive");
        emptyAssetDetails();
        emptyMediaDetails();
        setShowSimuliveForm(true);
      },
      clone: handleClone,
      duplicate: handleClone,
      download: handleDownload,
      podcast: () => {
        emptyAssetDetails();
        emptyMediaDetails();
        handlePodcast();
      },
    }),
    [
      handleClone,
      handleDownload,
      handlePodcast,
      emptyAssetDetails,
      emptyMediaDetails,
    ]
  );

  const handleMediaOptionValue = useCallback(
    (value: string) => {
      if (
        value &&
        mediaActionHandlers[value as keyof typeof mediaActionHandlers]
      ) {
        mediaActionHandlers[value as keyof typeof mediaActionHandlers]();
      }
      setShowMoreOptions(false);
    },
    [mediaActionHandlers]
  );

  const handleClose = useCallback(() => {
    setShowDuplicateForm(false);
    setShowSimuliveForm(false);
  }, []);

  const handleDelete = () => {
    getUpdateMedia({
      ...media,
      media_status: 3,
      media_state: 3,
    } as any);
    const { list, count } = store.getState().media.mediaList;
    store.dispatch(
      setMediaList({
        data: {
          list: list.filter((m) => m.id !== media.id),
          count: count - 1,
        },
      })
    );
    setConfirmModalOpen(false);
    setIsMediaDeleteModalOpen(false);
  };

  const handleReuploadClick = () => {
    reuploadInputRef.current?.click();
  };

  // Reupload must replace the media with the same kind of file it already
  // is — video assets only accept video files, audio assets only mp3 (not
  // the broader wav/aac ALLOWED_FILE_EXTENSION.AUDIO list).
  const reuploadAllowedExtensions =
    media.asset_type === "audio"
      ? ["mp3"]
      : media.asset_type === "video"
        ? ALLOWED_FILE_EXTENSION.VIDEO
        : null;

  const handleReuploadFileSelected = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    if (reuploadAllowedExtensions) {
      const extension = file.name.split(".").pop()?.toLowerCase() ?? "";
      if (!reuploadAllowedExtensions.includes(extension)) {
        toast.fail(
          media.asset_type === "audio"
            ? "Only .mp3 files are allowed for this reupload"
            : "Only video files are allowed for this reupload"
        );
        return;
      }
    }

    setIsReuploading(true);
    trackContentAction("Reupload");

    await runMediaReupload(media, file, {
      reuploadMedia,
      getMedia,
      getChunkInfo,
      addFile,
      increaseCounter,
      decreaseCounter,
      showUploadProgress,
      updateFileProgress,
      setUploadedSuccessfully,
      setUploadingError,
      onReuploadSettled: () => setIsReuploading(false),
      onMediaRefetched: (refetchedMedia) => {
        setClonedMedia?.(refetchedMedia);
        setIsMediaModalOpen(true);
        onPreviewModalClose?.();
      },
    });
  };

  const handleSimuliveOpen = useCallback(() => {
    setIsMediaModalOpen(true);
    setFooterBtnContent("Done");
    handleClose();
  }, [handleClose]);

  const handleFormSubmit = useCallback(
    (formData: {
      id: string;
      reason: string;
      notes?: string;
      socials: string[];
    }) => {
      deleteMedia({ ...formData }, archiveActionType);
      if (archiveActionType === "delete") {
        getUpdateMedia({
          ...media,
          media_status: 3,
          media_state: 3,
        } as any);
        const { list, count } = store.getState().media.mediaList;
        store.dispatch(
          setMediaList({
            data: {
              list: list.filter((m) => m.id !== media.id),
              count: count - 1,
            },
          })
        );
      }
      setIsMediaDeleteModalOpen(false);
    },
    [deleteMedia, getUpdateMedia, archiveActionType, media]
  );

  const shouldRenderActionButtons = useMemo(
    () =>
      media.media_status === 2 ||
      media.media_status === 3 ||
      media?.content_type === 2,
    [media.media_status]
  );

  const renderModals = () => (
    <>
      {showSimuliveForm && (
        <Modal
          isOpen={showSimuliveForm}
          width="900px"
          height="auto"
          onClose={hideSimuliveForm}
          title="Create > Simulive"
          footer={
            <div className="d-flex justify-content-end ">
              <Button
                type="outline-primary"
                isDisabled={isFooterBtnDisabled}
                onClick={() => {
                  const event = new Event("nextClickSimulive");
                  window.dispatchEvent(event);
                }}
              >
                {footerBtnText}
              </Button>
            </div>
          }
        >
          <SimuliveForm
            closeModal={hideSimuliveForm}
            openModal={handleSimuliveOpen}
            slikeId={media.id}
            fromList={true}
            autoValidateOnMount={true}
            setClonedMedia={setClonedMedia}
            setFooterBtnText={setFooterBtnText}
            setIsFooterBtnDisabled={setIsFooterBtnDisabled}
          />
        </Modal>
      )}
      {isMediaDeleteModalOpen && (
        <MediaDelete
          ref={mediaDeleteRef}
          media={media}
          onClose={() => setIsMediaDeleteModalOpen(false)}
          actionType={archiveActionType}
          isOpen={isMediaDeleteModalOpen}
          onFormSubmit={handleFormSubmit}
        />
      )}
    </>
  );

  return media?.state !== -2 ? (
    <div className="d-flex flex-row gap-2 align-items-center render-action">
      {(shouldRenderActionButtons || mediaState?.isDrive) &&
        !fromLibraryPreview && (
          <Tooltip content="Copy ID">
            <div
              className={`btn btn-sm btn-outline-primary fs-6 me-auto ${styles["hover-filter"]}`}
              onClick={async (e) => {
                e.stopPropagation();
                trackContentAction("Slike ID", "copy");
                const result = await copyTextToClipboard(media.id);
                if (result) {
                  toast.success("ID copied to clipboard");
                } else {
                  toast.fail("Failed to copy ID");
                }
              }}
            >
              {media.id}
            </div>
          </Tooltip>
        )}
      {!mediaState?.isDrive && renderDraftButton()}
      {renderLibraryButtons()}
      {renderEditButton()}
      {shouldRenderActionButtons && (
        <>
          {renderSendButton()}
          {renderTrimButton()}
          {!fromLibraryPreview && renderDownloadButton()}
          {!fromLibraryPreview && renderMoreOptionsDropdown()}
        </>
      )}
      {renderModals()}
      {isTrimmerOpen && (
        <VideoTrimmer
          isOpen={isTrimmerOpen}
          onClose={handleTrimmerClose}
          media={media}
          onTrimComplete={(trimmedMedia: any) => {
            setIsTrimmerOpen(false);
            if (trimmedMedia && trimmedMedia.id) {
              setClonedMedia?.(trimmedMedia);
              setMediaDetails({
                data: {
                  media: trimmedMedia,
                },
              });
              setIsMediaModalOpen(true);
            }
          }}
          trimMedia={trimMedia}
          updateModal={updateModal}
          presetList={presetList}
          preMediaList={preMediaList}
          postMediaList={postMediaList}
          getListMedia={getListMedia}
          getSearchedListMedia={getSearchedListMedia}
          getPresetList={getPresetList}
          getMedia={getMedia}
          currentTab={tab}
        />
      )}
    </div>
  ) : (
    <div className="d-flex flex-row gap-2 align-items-center">
      <input
        ref={reuploadInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={handleReuploadFileSelected}
        accept={
          reuploadAllowedExtensions
            ? reuploadAllowedExtensions.map((ext) => `.${ext}`).join(",")
            : undefined
        }
      />
      <Button
        type="outline-primary"
        isDisabled={isReuploading}
        onClick={handleReuploadClick}
      >
        <RotateCw size={14} className="me-1" />
        {isReuploading ? "Reuploading..." : "Reupload"}
      </Button>
      <Button type="danger" onClick={() => setConfirmModalOpen(true)}>
        <Trash size={14} className="me-1" /> Delete
      </Button>
      {isConfirmModalOpen && (
        <AlertDialog
          isOpen={isConfirmModalOpen}
          onClose={() => setConfirmModalOpen(false)}
          onConfirm={handleDelete}
          title="ALERT!"
          message="Are you sure you want to leave? Any unsaved changes will be lost."
          confirmText="Confirm"
          cancelText="Cancel"
          confirmButtonType="warning"
        />
      )}
    </div>
  );
};

const mapState = (state: RootState) => ({
  currentMediaDetailsForEdit: state.media.mediaDetails.media,
  businessProductConstants: state.app.businessProductConstants,
  metaLanguage: state.app.metaLanguage,
  preMediaList: state.media.preMediaList.list,
  postMediaList: state.media.postMediaList.list,
  presetList: state.media.presetList.list,
  isModalOpen: state.app.isModalOpen,
  bunchProductList: state.constants.bunchProductList.list,
});

const mapDispatch = {
  deleteMedia,
  getUpdateMedia,
  setMediaDetails,
  emptyAssetDetails,
  emptyMediaDetails,
  getMedia,
  callRegisterCustomMediaOnCms,
  trimMedia,
  updateModal,
  getSearchedListMedia,
  getListMedia,
  getPresetList,
  getTokenForDownload,
  reuploadMedia,
  getChunkInfo,
  addFile,
  increaseCounter,
  decreaseCounter,
  updateFileProgress,
  setUploadedSuccessfully,
  setUploadingError,
  showUploadProgress,
};

const connector = connect(mapState, mapDispatch);
type CProps = ConnectedProps<typeof connector>;

interface CombinedProps {
  media: MediaModel;
  paramFilter: URLSearchParams;
  tab?: string;
  setIsMediaModalOpen: (isOpen: boolean) => void;
  setIsSocialModalOpen: (isOpen: boolean) => void;
  setFooterBtnContent: (content: string) => void;
  setClonedMedia?: (media: MediaModel) => void;
  onPreviewModalClose?: () => void;
  onRequestTrim?: (media: MediaModel) => void;
  onCloneInitiated?: () => void;
  showCtaText?: boolean;
  fromLibraryPreview?: boolean;
  libraryCtaOrd?: string[];
  onDropdownStateChange?: (isOpen: boolean) => void;
}

type Props = CProps & CombinedProps;

export default connector(RenderAction);
